import React from 'react';

import { CustomCellRendererProps } from 'ag-grid-react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import {
  formatPartnershipPercent,
  getPartnershipOptions,
  getPartnershipPartners,
  getPartnershipRatio,
  isSpecialBillingPartnership,
} from '../../utils/partnership';

export const PartnershipCellRenderer = ({
  data,
}: CustomCellRendererProps): React.ReactElement | null => {
  const { t } = useTranslation();
  const partnership = data?.partnership;
  const partners = getPartnershipPartners(partnership);

  if (partners.length === 0) return null;

  const isSpecialBilling = isSpecialBillingPartnership(partnership);
  const ratio = getPartnershipRatio(partners);
  const typeLabel = isSpecialBilling
    ? t('chuteScheduler.specialBilling')
    : t('chuteScheduler.donorPartnership');
  const tooltip = [
    typeLabel,
    ...getPartnershipOptions(partnership).map(({ slot, account }) =>
      t('chuteScheduler.partnershipOption', { slot, account }),
    ),
  ].join('\n');

  return (
    <span className="flex items-center gap-2 overflow-hidden" title={tooltip}>
      <span
        className={clsx(
          'inline-flex h-5 shrink-0 items-center justify-center rounded-full px-1.5 text-xs font-semibold text-white',
          isSpecialBilling ? 'bg-purple-500' : 'bg-green-500',
        )}
      >
        {isSpecialBilling ? 'SB' : 'P'}
      </span>
      {ratio && <span className="shrink-0 font-semibold">{ratio}</span>}
      <span className="truncate">
        {partners
          .map(
            (partner) =>
              `${partner.name} (${formatPartnershipPercent(partner.percent)}%)`,
          )
          .join(', ')}
      </span>
    </span>
  );
};
